import WebWxUserEdit from './WebWxUserEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Button, Space } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebWxOpenId from './WebWxOpenId';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';
import { getColumnsheadId } from '../../../utilsTsx/components/system/columnshead';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import RoleOrUserLicense from '../../basic/license/RoleOrUserLicense';

const WebWxUser = (props: any) => {
    const apiId = 'webWxUser';
    const ref = useRef<any>(undefined);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalData, setModalData] = useState({});
    /** 默认后台service */
    const [defaultService, setDefaultService] = useState<any>();
    /** 刷新 */
    const [fetchData, setFetchData] = useState<any>();
    const [roleData, setRoleData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>()
    const [modalWxUserLicense, setModalWxUserLicense] = useState(false);
    const [wxUserInfo, setWxUserInfo] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'role',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setRoleData([{ id: 'ALLITEM', roleName: '所有' }, ...res.data]);
            }
        })
    }, []);

    const handleWxUserLicense = (record: any) => {
        setWxUserInfo({
            roleOrUserId: record.unionId,
            itemName: record.nickName
        });
        setModalWxUserLicense(true);
    };

    const onVisibleModalWxOpenId = (state: boolean) => {
        setModalVisible(state);
    }

    //表头
    const columnsHead = [
        {
            title: '昵称',
            dataIndex: 'nickName',
            sorter: true,
        },
        {
            title: '角色',
            dataIndex: 'role',
            render: (val: any) => {
                let roleName = '';
                if (val) {
                    for (let i = 0; i < val.length; i++) {
                        const element = val[i];
                        if (roleName !== '') { roleName += ','; }
                        roleName += element?.roleName;
                    }
                }
                return roleName;
            }
        },
        {
            title: '头像',
            dataIndex: 'avatarUrl',
            render: (image: any) => <img src={image} width='60' alt="头像" />
        },
        {
            title: '手机',
            dataIndex: 'mobile',
        },
        {
            title: 'wxOpenId',
            dataIndex: 'wxOpenId',
            render: (val: any, record: any) => (
                <Button type='dashed' onClick={() => {
                    onVisibleModalWxOpenId(true);
                    setModalData({
                        unionId: record.unionId
                    });
                    onVisibleModalWxOpenId(true);
                }}>{'wxOpenId'}</Button>
            )
        },
        {
            title: '权限',
            dataIndex: 'operation',
            key: 'operation',
            render: (val: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleWxUserLicense(record)}>权限</Button>
                </Space>
        },
    ];

    const columns = getColumnsheadId({
        title: '微信',
        dataIndex: 'unionId',
        pos: 'suffix'
    }).concat(columnsHead as []);

    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '微信用户',
        apiId,
        columns,
        primaryKeyName: 'unionId',
        displayOptions: {
            showAdd: false,
            loggerProps: {
                showLogger: true,
                showSingleLogger: true,
                LoggerTypes,
                loggerTypeId: 'OP'
            }
        },
        editOptions: {
            Editor: WebWxUserEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='roleId'
                getListData={roleData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="roleName"
            />
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalWxUserLicense ? (<RoleOrUserLicense
                closeModal={() => setModalWxUserLicense(false)}
                info={wxUserInfo}
                useType={'webWxUserLicense'} />)
                : null}
            {modalVisible ? (<WebWxOpenId closeModal={() => onVisibleModalWxOpenId(false)} data={modalData} />) : null}
        </>
    )
}

export default WebWxUser;
